export default "__VITE_ASSET__CnDGEUdp__"